<ul class="grid">
  <ng-container
    *ngFor="let chunk of list | chunked: chunkSize; index as lazyChunkIndex"
    data-dgat="lazy-chunk-b09"
  >
    <li
      dgxIntersectionObserver
      (onIntersection)="renderChunk(lazyChunkIndex, chunk)"
      [options]="options"
      role="presentation"
    ></li>
    <li
      *ngFor="let localItem of chunk; trackBy: trackBy; index as itemIndex"
      data-dgat="lazy-chunk-ffa"
      [class.grid__col-lg-3]="rowLength === 4"
      [class.grid__col-lg-4]="rowLength === 3"
      class="grid__col-xs-12 grid__col-sm-6 grid__col-md-4"
    >
      <ng-container *ngIf="chunkRendered[lazyChunkIndex]; else loading">
        <ng-container
          *ngTemplateOutlet="template; context: { $implicit: { localItem, itemIndex, lazyChunkIndex } }"
        ></ng-container>
      </ng-container>

      <!-- Loading template -->
      <ng-template #loading>
        <div
          class="tile tile--stub"
          [style.height.rem]="loadingTemplateHeight"
        ></div>
      </ng-template>
    </li>
  </ng-container>
</ul>
